<template>
    <div class="content-page">
        <div class="container-fluid">
            <div class="sales-filter">
                <div class="filter_from pb-3">
                    <div class="row">
                        <div class="col-12">
                            <div class="head">
                                <h4 class="text-center">Ageing Summary</h4>
                            </div>
                            <div class="order_table mt-4">
                                <div class="table-responsive rounded mb-3">
                                    <table class="table mb-0 tbl-server-info" style="width: 98%;">
                                        <thead class="bg-white text-uppercase">
                                            <tr class="ligth ligth-data">
                                                <th class="text-start">7 Days</th>
                                                <th class="text-start">15 Days</th>
                                                <th class="text-start">30 Days</th>
                                                <th class="text-start">60 Days</th>
                                                <th class="text-start">Over 60 Days</th>
                                                <th class="text-start">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody class="ligth-body">
                                            <tr>
                                                <td class="text-start"><a @click="search('7')"
                                                        href="javascript:void(0)">{{ currency(summary.days_7, '') }}</a>
                                                </td>
                                                <td class="text-start"><a @click="search('15')"
                                                        href="javascript:void(0)">{{ currency(summary.days_15, '')
                                                        }}</a></td>
                                                <td class="text-start"><a @click="search('30')"
                                                        href="javascript:void(0)">{{ currency(summary.days_30, '')
                                                        }}</a></td>
                                                <td class="text-start"><a @click="search('60')"
                                                        href="javascript:void(0)">{{ currency(summary.days_60, '')
                                                        }}</a></td>
                                                <td class="text-start"><a @click="search('60+')"
                                                        href="javascript:void(0)">{{ currency(summary.over_60_days, '')
                                                        }}</a></td>
                                                <td class="text-start"><a @click="search('all')"
                                                        href="javascript:void(0)">{{ currency(summary.total, '') }}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>
                    <div class="row justify-content-between mt-4" style="flex-wrap: nowrap;">
                        <div class="col-lg-8 d-lg-flex gap-2 justify-content-between">
                            <div class="input mt-3">
                                <div class="label">Customer</div>
                                <select name="" id="" class="select2" ref="customer" @change="search()">
                                    <option value="">Select Customer</option>
                                    <option :value="customer['id']" v-for="customer in customers">{{ customer['name'] }}
                                    </option>
                                </select>
                            </div>

                            <div class="input mt-3">
                                <div class="label">Report Type</div>
                                <select name="" id="" ref="report_status" @change="search()">
                                    <option value="pending">Pending Credits</option>
                                    <option value="paid">Paid Credits</option>
                                    <option value="all">All Credits</option>
                                </select>
                            </div>

                            <div class="input mt-3">
                                <div class="label">From Date</div>
                                <input type="date" name="from_date" ref="from_date" id="" @change="search()">
                            </div>
                            <div class="input mt-3">
                                <div class="label">To Date</div>
                                <input type="date" name="to_date" ref="to_date" id="" @change="search()">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="input mt-3 text-end">
                                <a v-if="report_type != null && report_type['type'] == 'customer'"
                                    class="btn bg-info mr-2" href="javascript:void(0)"
                                    @click="payCredit(report_type['value'])" title="Pay">Pay Cash</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="head mt-5">
                <h4>Credits</h4>
            </div>
            <div class="order_table mt-4">
                <div class="table-responsive rounded mb-3">
                    <table class="data-table table mb-0 tbl-server-info" style="width: 98%;">
                        <thead class="bg-white text-uppercase">
                            <tr class="ligth ligth-data">
                                <th class="text-start">Customer</th>
                                <th class="text-start">Pending Amount</th>
                                <th class="text-start">Order Number</th>
                                <th class="text-start">Credit Date</th>
                                <th class="text-start">Last Paid</th>
                                <th class="text-start">Action</th>
                            </tr>
                        </thead>
                        <tbody class="ligth-body">
                            <tr v-for="item in credit">
                                <td class="text-start">{{ getCustomer(item['customer_id']) != undefined ?
                                    getCustomer(item['customer_id'])['name'] : '' }}</td>
                                <td class="text-start">{{ item['ammount'] }}</td>
                                <td class="text-start">{{ item['order_id'] }}</td>
                                <td class="text-start">{{ new Date(item['created_at']).toLocaleString('nl-NL') }}</td>
                                <td class="text-start">{{ new Date(item['updated_at']).toLocaleString('nl-NL') }}</td>
                                <td class="text-start">
                                    <div class="d-flex align-items-center list-action justify-content-start">
                                        <a class="badge bg-success mr-2" href="javascript:void(0)" title="Pay Now"
                                            @click="payCredit(item['id'])">Pay</a>

                                        <a class="badge bg-primary mr-2" href="javascript:void(0)" title="View"
                                            @click="getHistory(item['id'])"><i class="fa-regular fa-eye"></i></a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <div class="head mt-5">
                        <h4>Total</h4>
                    </div>
                    <div class="order_table mt-4">
                        <div class="table-responsive rounded mb-3">
                            <table class="history-table table mb-0 tbl-server-info" style="width: 98%;">
                                <thead class="bg-white text-uppercase">
                                    <tr class="ligth ligth-data">
                                        <th class="text-start w-50">Total Bills</th>
                                        <th class="text-start w-50">Total Amount</th>
                                    </tr>
                                </thead>
                                <tbody class="ligth-body">
                                    <tr>
                                        <td class="text-start">{{ total_bills }}</td>
                                        <td class="text-start">{{ currency(total_amount, '') }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="head mt-5">
                        <h4>Credit Payment History</h4>
                    </div>
                    <div class="order_table mt-4">
                        <div class="table-responsive rounded mb-3">
                            <table class="history-table table mb-0 tbl-server-info" style="width: 98%;">
                                <thead class="bg-white text-uppercase">
                                    <tr class="ligth ligth-data">
                                        <th class="text-start w-50">Date</th>
                                        <th class="text-start w-50">Amount</th>
                                    </tr>
                                </thead>
                                <tbody class="ligth-body">
                                    <tr v-for="history in histories">
                                        <td class="text-start">{{ new Date(history['created_at']).toLocaleString('nl-NL') }}
                                        </td>
                                        <td class="text-start">{{ history['ammount'] }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="PaymentModal" tabindex="-1" role="dialog" aria-labelledby="PaymentModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body p-5">
                    <div class="row row-cols-lg-2">
                        <div class="col">
                            <div class="head">
                                <h4>Enter amount to pay</h4>
                            </div>
                            <div class="form-group mt-4">
                                <label>Amount</label>
                                <input ref="amount" type="text" class="form-control" placeholder="Enter Amount">
                            </div>
                            <button class="btn btn-info text-light" @click="payNow()">Pay Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="loadingModal" tabindex="-1" role="dialog" aria-labelledby="loadingModalTitle"
        aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content bg-transparent border-0" style="box-shadow: none;">
                <div class="modal-body d-flex" style="justify-content: center; box-shadow: none;">
                    <div class="spinner-border text-primary" style="width: 4rem; height: 4rem;" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import toastr from 'toastr';
import { currency, isNumber } from '../custom';

export default {
    props: ['credits', 'customers', 'summary', 'isadmin'],
    data() {
        return {
            name: 'dashboardCredits',
            credit: this.credits,
            histories: [],
            payID: 0,

            report_type: null,
            total_amount: 0,
            total_bills: 0,
            date_vise_payments: 0,
            date_vise_cash: 0,
            date_vise_cheque: 0,
            date_vise_total: 0,
        }
    },

    methods: {
        currency,
        getCustomer(id) {
            return this.customers.filter(item => item['id'] == id)[0];
        },
        async search(day = 'none') {

            this.credit = [];
            $(".data-table").DataTable().destroy();
            var customer = this.$refs.customer.value;

            const { data } = await axios.post("/dashboard/credits/get-credits", {
                params: {
                    customer_id: customer,
                    days: day,
                    report_status: this.$refs.report_status.value,
                    from_date: this.$refs.from_date.value,
                    to_date: this.$refs.to_date.value,
                }
            });

            this.credit = data;

            this.histories = [];

            this.total_amount = 0;
            this.total_bills = 0;

            this.credit.forEach(element => {
                this.total_amount += element['ammount']
            });

            this.total_bills = this.credit.length;

            setTimeout(function () {
                $(".data-table").DataTable().order([3, 'desc']).draw();
            }, 500);

            if (data.length > 0) {
                if (day == 'none') {
                    this.report_type = {
                        type: 'customer',
                        value: customer,
                    };
                }
                else {
                    this.report_type = {
                        type: 'day',
                        value: day,
                    };
                }
            }
            else {
                this.report_type = null;
            }

            return 0;
        },
        getHistory(id) {
            $(".history-table").DataTable().destroy();
            this.histories = this.credit.filter(item => item['id'] == id)[0]['history'].sort((b, a) => {
                if (a.created_at < b.created_at) return -1;
                if (a.created_at > b.created_at) return 1;
                return 0;
            });

            setTimeout(function () {
                $(".history-table").DataTable().order([0, 'desc']).draw();
            }, 500);
        },
        payCredit(credit = 0) {
            if (this.$refs.customer.value == '' || this.$refs.customer.value == 0 || this.$refs.customer.value == 'all') {
                toastr.error('Please select a customer', 'Error');
                return;
            }

            if (credit != 0) {
                this.payID = credit;
                this.$refs.amount.value = this.credit.filter(item => item['id'] == credit)[0]['ammount'];
            }

            $("#PaymentModal").modal('show');
        },
        async payNow() {
            var credit = this.$refs.customer.value;
            var amount = this.$refs.amount.value;
            if (credit == '' || credit == 0 || credit == 'all') {
                toastr.error('Invalid customer', "Error");
                return false;
            }

            if (!isNumber(amount)) {
                toastr.error('Please enter amount in number only', "Error");
                return false;
            }

            $("#PaymentModal").modal('hide');
            $("#loadingModal").modal('show');

            const { data } = await axios.post("/dashboard/credits/pay-credit", {
                params: {
                    credit: this.payID == 0 ? credit : this.payID,
                    amount: amount,
                    type: this.payID == 0 ? 'auto' : 'manual',
                }
            });

            $("#loadingModal").modal('hide');

            if (data.error == 0) {
                $("#loadingModal").modal('hide');

                toastr.success('Credit paid', 'Success');

                this.search();

                this.$refs.amount.value = '0';

                let objFra = document.createElement('iframe');
                objFra.style.visibility = 'hidden';
                objFra.src = '/credit-invoice/' + data.bill;
                document.body.appendChild(objFra);
                objFra.contentWindow.focus();
                objFra.contentWindow.print();
            }
            else {
                toastr.error(data.msg, "Error");
            }

            setTimeout(function () {
                $("#loadingModal").modal('hide');
            }, 1000);

        }
    },
    beforeMount() {
    },
    mounted() {
        // Initialize select2
        $(this.$refs.customer).select2();

        // Listen to the select2 change event
        $(this.$refs.customer).on("change", (event) => {
            this.search();
        });
    }
}
</script>
